import React from 'react';
import cx from 'classnames';

import { useCurrency } from 'app/context/CurrencyContext';

import s from './CurrencySwitcher.module.sass';

type CurrencySwitcherProps = {
  className?: string
};

export enum CurrencyEnum {
  USD = 'USD',
  XTZ = 'XTZ',
}

const CurrencySwitcher: React.FC<CurrencySwitcherProps> = ({ className }) => {
  const { currency, setCurrency } = useCurrency();

  const compoundClassName = cx(
    s.root,
    { [s.switch]: currency === CurrencyEnum.USD },
    className,
  );

  return (
    <div className={compoundClassName}>
      <button
        type="button"
        className={cx(s.currency, { [s.xtz]: currency === CurrencyEnum.XTZ })}
        onClick={setCurrency.bind(null, CurrencyEnum.XTZ)}
      >
        xtz
      </button>

      <button
        type="button"
        className={cx(s.currency, { [s.usd]: currency === CurrencyEnum.USD })}
        onClick={setCurrency.bind(null, CurrencyEnum.USD)}
      >
        usd
      </button>
    </div>
  );
};

export default CurrencySwitcher;
